export const poam_header = [
  "POAM ID",
  "Controls",
  "Weakness Name",
  "Weakness Description",
  "Weakness Detector Source",
  "Weakness Source Identifier",
  "Asset Identifier",
  "Point of Contact",
  "Resources Required",
  "Overall Remediation Plan",
  "Original Detection Date",
  "Scheduled Completion Date",
  "Planned Milestones",
  "Milestone Changes",
  "Status Date",
  "Vendor Dependency",
  "Last Vendor Check-in Date",
  "Vendor Dependent Product Name",
  "Original Risk Rating",
  "Adjusted Risk Rating",
  "Risk Adjustment",
  "False Positive",
  "Operational Requirement",
  "Deviation Rationale",
  "Supporting Documents",
  "Comments",
  "Auto-Approve",
  "justification",
    "BOD 22-01 Tracking",
  "BOD 22-01 Due Date",
  "CVE",
  "Service Names"
];

export const secondary_columns = [
  "Auto-Approve",
  "Supporting Documents",
  "Risk Adjustment",
  "Original Risk Rating",
];

export const hidden_columns = ["justification"];

export const columns_width = [
  130, // POAM ID
  200, // Controls
  200, // Weakness Name
  400, // Weakness Description
  500, // Weakness Detector Source
  500, // Weakness Source Identifier
  500, // Asset Identifier
  300, // Point of Contact
  300, // Resources Required
  300, // Overall Remediation Plan
  280, // Original Detection Date
  280, // Scheduled Completion Date
  300, // Planned Milestones
  400, // Milestone Changes
  210, // Status Date
  250, // Vendor Dependency
  250, // Last Vendor Check-in Date
  300, // Vendor Dependent Product Name
  250, // Original Risk Rating
  250, // Adjusted Risk Rating
  170, // Risk Adjustment
  180, // False Positive
  250, // Operational Requirement
  300, // Deviation Rationale
  400, // Supporting Documents
  300, // Comments
  150, // Auto-Approve
  300, // justification
  200, // BOD 22-01 Tracking
  200, // BOD 22-01 Due Date
  150, // CVE
  250  // Service Names
];


// Mapping of names that come in response from backend, to names that are required by frontend to populate data
export const poam_header_response_map = {
  "id": "id",
  "framework_id": "framework_id",
  "framework_name": "framework_name",
  "is_open": "is_open",
  "poam_id": "POAM ID",
  "controls": "Controls",
  // "control": "Control",
  "weakness_name": "Weakness Name",
  "weakness_description": "Weakness Description",
  "weakness_detector_source": "Weakness Detector Source",
  "weakness_source_identifier": "Weakness Source Identifier",
  "asset_identifier": "Asset Identifier",
  "point_of_contact": "Point of Contact",
  "resources_required": "Resources Required",
  "overall_remediation_plan": "Overall Remediation Plan",
  "original_detection_date": "Original Detection Date",
  "scheduled_completion_date": "Scheduled Completion Date",
  "planned_milestones": "Planned Milestones",
  "milestone_changes": "Milestone Changes",
  "status_date": "Status Date",
  "vendor_dependency": "Vendor Dependency",
  "last_vendor_checkin_date": "Last Vendor Check-in Date",
  "vendor_dependent_product_name": "Vendor Dependent Product Name",
  "original_risk_rating": "Original Risk Rating",
  "adjusted_risk_rating": "Adjusted Risk Rating",
  "risk_adjustment": "Risk Adjustment",
  "false_positive": "False Positive",
  "operational_requirement": "Operational Requirement",
  "deviation_rationale": "Deviation Rationale",
  "supporting_documents": "Supporting Documents",
  "comments": "Comments",
  "auto_approve": "Auto-Approve",
  "justification": "justification",
  "jira_issues": "jira_issues",
  "extra_field": "extra_field",
  "poam_file": "poam_file",
  "bod_22_01_tracking": "BOD 22-01 Tracking",
  "bod_22_01_due_date": "BOD 22-01 Due Date",
  "cve": "CVE",
  "service_names": "Service Names"
};

export const poam_header_reverse_map = {
  "POAM ID": "poam_id",
  "Controls": "controls",
  "Weakness Name": "weakness_name",
  "Weakness Description": "weakness_description",
  "Weakness Detector Source": "weakness_detector_source",
  "Weakness Source Identifier": "weakness_source_identifier",
  "Asset Identifier": "asset_identifier",
  "Point of Contact": "point_of_contact",
  "Resources Required": "resources_required",
  "Overall Remediation Plan": "overall_remediation_plan",
  "Original Detection Date": "original_detection_date",
  "Scheduled Completion Date": "scheduled_completion_date",
  "Planned Milestones": "planned_milestones",
  "Milestone Changes": "milestone_changes",
  "Status Date": "status_date",
  "Vendor Dependency": "vendor_dependency",
  "Last Vendor Check-in Date": "last_vendor_checkin_date",
  "Vendor Dependent Product Name": "vendor_dependent_product_name",
  "Original Risk Rating": "original_risk_rating",
  "Adjusted Risk Rating": "adjusted_risk_rating",
  "Risk Adjustment": "risk_adjustment",
  "False Positive": "false_positive",
  "Operational Requirement": "operational_requirement",
  "Deviation Rationale": "deviation_rationale",
  "Supporting Documents": "supporting_documents",
  "Comments": "comments",
  "Auto-Approve": "auto_approve",
  "justification": "justification",
  "BOD 22-01 Tracking": "bod_22_01_tracking",
  "BOD 22-01 Due Date": "bod_22_01_due_date",
  "CVE": "cve",
  "Service Names": "service_names"
};




export const columnTooltips = {
  "POAM ID": "Unique identifier for each POAM Item",
  "Controls": "Applicable 800-53 Control(s)",
  "Weakness Name": "Name of the weakness as provided by the scanner or otherwise summarizing the weakness",
  "Weakness Description": "Description of the weakness and other information",
  "Weakness Detector Source": "The scanner name or other source that detected the vulnerability",
  "Weakness Source Identifier": "Vulnerability identifier (Plugin ID) as provided by scanner (plugin ID/None)",
  "Asset Identifier": `Identifier Specified in the Inventory
This is a unique string associated with the asset, it could just be IP, or any arbitrary naming scheme.
This Field should include the complete identifier (no short hand), along with the port and protocol when provided by the scanner.
Each Asset should be separated by a new line (Alt+Enter)`,
  "Point of Contact": "Person Responsible for implementing this task",
  "Resources Required": "Specify resources needed beyond current resources to mitigate task",
  "Overall Remediation Plan": "General overview of the remediation plan",
  "Original Detection Date": "Date the weakness was first identified (aka Discovery Date)",
  "Scheduled Completion Date": "Permanent Column — Date of intended completion",
  "Planned Milestones": `Permanent Column
List of proposed Milestones, separated with a blank line (Alt+Enter).
Any alterations should be made in "Milestone Changes".
Milestone Number should be unique to each milestone.`,
  "Milestone Changes": `Any alterations, status updates, or additions to the milestones.
(Milestone Number) [Type of update] [milestone date] : How and why the date changed, or the milestone was altered.
Create a new Milestone Number for new Milestones.`,
  "Status Date": "Date POA&M item was last changed or closed",
  "Vendor Dependency": "Whether or not this item is vendor dependent",
  "Last Vendor Check-in Date": "Date of last vendor check-in, if applicable",
  "Vendor Dependent Product Name": "Name of the product that is dependent upon the vendor",
  "Original Risk Rating": "Provide the Original Risk Rating from the scanner",
  "Adjusted Risk Rating": "Provide the Adjusted Risk Rating as approved by the CIO",
  "Risk Adjustment": "Whether there was a Risk Adjustment",
  "False Positive": "Whether this weakness should be considered a False Positive",
  "Operational Requirement": "Whether this weakness should be considered an Operational Requirement",
  "Deviation Rationale": "Information about the Deviation",
  "Supporting Documents": `List any supporting documents that are associated with this item
(e.g. Deviation Request, Evidence of Remediation, Evidence of Vendor Dependency, etc)`,
  "Comments": "This column is for additional information, not specified in another column",
  "Auto-Approve": "Whether the deviation request was auto-approved or manually approved",
  "justification": "Whether this vulnerability is listed among the CISA Known Exploited Vulnerability Catalog",
  "BOD 22-01 Tracking": "If this vulnerability is listed among the CISA Known Exploited Vulnerability Catalog include the due date given by CISA for this vulnerability",
  "BOD 22-01 Due Date": "Due date from CISA for the vulnerability",
  "CVE": "The associated CVE numbers for this vulnerability",
  "Service Names": `The associated service this vulnerability affects on the CSPs system.
This should be the unique name (no shorthand) of the service/offering as the purchaser would see it.
Each service/offering should be separated by a new line (Alt+Enter).`
};
